function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "logo");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.000312696524 0.473914894 30.8505627 0.473914894 30.8505627 73.2124736 0.000312696524 73.2124736"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0.035334285 0.54852468 21.340237 0.54852468 21.340237 44.0851064 0.035334285 44.0851064"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Phone_index",
  transform: "translate(-255.000000, -7493.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "transparent",
  x: 0,
  y: 0,
  width: 750,
  height: 7800
}), /*#__PURE__*/React.createElement("g", {
  id: "huobi",
  transform: "translate(79.000000, 7485.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "logo",
  transform: "translate(176.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-16"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-15"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.8505627,22.8602532 C30.8505627,12.4160191 25.8123932,3.43525319 21.9795797,0.509891489 C21.9639864,0.501231915 21.6864271,0.343785106 21.7098169,0.761019149 C21.7098169,0.766529787 21.705139,0.768891489 21.705139,0.773614894 C21.385478,20.9394021 11.1836136,26.4043809 5.5747322,33.7665936 C-7.3692,50.7558915 4.6687661,69.3834234 16.9273763,72.8259979 C23.7860542,74.7523596 15.3431051,69.4180617 14.255478,58.1503809 C12.9409695,44.5304447 30.8505627,34.1342319 30.8505627,22.8602532",
  id: "Fill-14",
  fill: "#1D2243",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-19",
  transform: "translate(24.169492, 29.127660)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-18"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5627559,0.597825532 C12.4840102,0.544293617 12.3725186,0.507293617 12.2953322,0.635612766 C12.0848237,3.17444255 9.51662034,8.60399574 6.26153559,13.5903362 C-4.77768475,30.5024851 1.5134,38.6542936 5.05150169,43.0336766 C7.10512881,45.5756553 5.05150169,43.0336766 10.1847898,40.4358043 C10.5870949,40.2319106 20.2018746,34.7874 21.2435017,22.382166 C22.2516034,10.3697617 15.1060102,2.79735745 12.5627559,0.597825532",
  id: "Fill-17",
  fill: "#0155FF",
  mask: "url(#mask-4)"
})))))));

var SvgHbLogo = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "74px",
    viewBox: "0 0 46 74",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHbLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hb-logo.8583556a.svg";
export { ForwardRef as ReactComponent };